/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onGetAddSpecial } from "../../Store/Slices/addSpecialListSlice";
import { useNavigate } from "react-router-dom";
import defaultImage from "../../Assets/fallbackimg_giftcard.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import { setProduct } from "../../Store/Slices/productDataSlice";
import { encryptURLParam } from "../../Common/Axios/encrypt";

import { ClientInfo, getImageUrl, trackEvent } from "../Utility/Utility";
const TrendingGiftCards = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const translation = getTranslationData();
  const loginAuthData = useSelector((state) => state.loginAuthReducer);

  useEffect(() => {
    if (loginAuthData?.data?.length) {
      dispatch(onGetAddSpecial());
      // dispatch(onGetAllocateBrand());
    }
  }, []);

  const addSpecialData = useSelector(
    (state) => state.addSpecialReducer.getData
  );
  // const sortedArray = useSelector(
  //   (state) => state?.allocateBrandReducer?.getAllocateBrandData
  // );

  // const productByClientData = useSelector(
  //   (state) => state.productReducer.productById?.[0]?.products
  // );

  // const productDiscount = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer.data?.[0]?.clientProductMapping
  // );

  // useEffect(() => {
  //   if (
  //     addSpecialData &&
  //     sortedArray &&
  //     productByClientData &&
  //     productDiscount
  //   ) {
  //     const filteredAddSpecialData =
  //       Array.isArray(addSpecialData) &&
  //       addSpecialData
  //         .filter((data) => data.enabled === true && data.isSpecial === false)
  //         .map((addSpecial) => {
  //           const allocatedBrands = sortedArray.filter(
  //             (brand) => brand.addSpecialId === addSpecial.id && brand.enabled
  //           );

  //           const arraySorted = Array.isArray(allocatedBrands)
  //             ? [...allocatedBrands].sort(
  //               (a, b) => a.displayOrder - b.displayOrder
  //             )
  //             : [];
  //           const products = arraySorted.map((brand) => {
  //             const product = productByClientData?.find(
  //               (product) => product.id === brand.productId
  //             );
  //             if (product) {
  //               const discount = productDiscount.find(
  //                 (discount) => discount.productId === product.id
  //               );
  //               const customerDiscount = discount && discount?.customerDiscount;
  //               return {
  //                 ...product,
  //                 customerDiscount,
  //                 priceDenomination: discount?.priceDenomination,
  //               };
  //             }
  //             return product;
  //           });
  //           const filteredArray = products.filter(
  //             (element) => element !== undefined
  //           );
  //           return {
  //             sectionName: addSpecial.sectionName,
  //             sectionDesc: addSpecial.description,
  //             buttonText: addSpecial.buttonText,
  //             displayOrder: addSpecial.displayOrder,
  //             products: filteredArray,
  //           };
  //         });

  //     Array.isArray(filteredAddSpecialData) &&
  //       filteredAddSpecialData?.sort((a, b) => a.displayOrder - b.displayOrder);
  //     setFinalData(filteredAddSpecialData);
  //     dispatch(setFilteredAddSpecial(filteredAddSpecialData));
  //   }
  // }, [
  //   addSpecialData,
  //   sortedArray,
  //   productByClientData,
  //   productDiscount,
  //   dispatch,
  // ]);
  useEffect(() => {
    if (!addSpecialData || addSpecialData.length === 0) return;
    // No need to calculate height anymore, using aspect-ratio CSS
  }, [addSpecialData]);

  useEffect(() => {
    // No need to listen to resize anymore, CSS aspect-ratio handles it
  }, []);
  

  const handleClick = (item, sectionName) => {
    dispatch(setProduct(item));
    // Conditionally encrypt the productId parameter based on environment setting
    const productId = item?.id.toString();
    const finalProductId =
      process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? productId
        : encryptURLParam(productId);
    navigate(`/giftcard?productId=${finalProductId}`);
  };

  // const [notFoundStates, setNotFoundStates] = useState([]);

  // const handleImageError = (index, productIndex) => {
  //   setNotFoundStates((prevState) => ({
  //     ...prevState,
  //     [`${index}-${productIndex}`]: true,
  //   }));
  // };

  const imageError = (e) => {
    e.target.onerror = null; // Prevent infinite loop if fallback fails
    e.target.src = defaultImage; // Set fallback
  };

  const getMaxPrice = (priceDenominations) => {
    if (priceDenominations) {
      const pricesArray = priceDenominations?.split(",");
      const pricesNumbers = pricesArray?.map(Number);
      return Math.max(...pricesNumbers);
    }
  };
  const getMinPrice = (priceDenominations) => {
    if (priceDenominations) {
      const pricesArray = priceDenominations?.split(",");
      const pricesNumbers = pricesArray?.map(Number);
      return Math.min(...pricesNumbers);
    }
  };

  const calculatePoints = (index, item) => {
    const productId = item.id;
    const maxPrice = getMaxPrice(item?.priceDenominations);
    const minPrice = getMinPrice(item?.priceDenominations);
    const discountEntry = addSpecialData[index]?.products?.find(
      (entry) => entry.id === productId
    );
    if (discountEntry) {
      if (discountEntry.minEarnPoints > 0) {
        return `${Math.round(
          (discountEntry.minEarnPoints / minPrice) *
            (maxPrice - (maxPrice * discountEntry.customerDiscount) / 100)
        )} ${translation?.points}`;
      }
    }
    return null;
  };

  const checkcalculatePoints = (index, item) => {
    const productId = item.id;
    const discountEntry = addSpecialData[index]?.products?.find(
      (entry) => entry.id === productId
    );
    if (discountEntry) {
      if (discountEntry.minEarnPoints > 0) {
        return true;
      }
    }
    return null;
  };
  const clientinfo = ClientInfo();
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isEarnView = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearnview"
  )?.configValue;
  
  return (
    <>
      <ScrollToTop />
      <div className="mainDiv">
        {Array.isArray(addSpecialData) &&
  addSpecialData
    .filter(
      (item) =>
        String(item?.visibleBy)?.toUpperCase() === "HOME"
    )
    .map((item, index) => {

            const validProducts =
              item?.products?.filter(
                (p) =>
                  p?.priceDenomination !== null &&
                  String(p?.priceDenomination).trim() !== "" &&
                  String(p?.priceDenomination).trim() !== "0"
              ) || [];

            const showMoreAfter = Number(item?.showMoreGiftCard)
              ? Number(item?.showMoreGiftCard)
              : 11;

            return (
              <div className="container" key={index}>
                {item?.products?.length > 0 && (
                  <h5 className="sec-below-head mtb">{item?.sectionName}</h5>
                )}

                <div className="row mt-2">
                  {validProducts
                    .slice(0, showMoreAfter)
                    .sort((a, b) => a.displayOrder - b.displayOrder)
                    .map((items, productIndex) => (
                      <div
                        className="col-md-2 col-sm-3 col-4 mb-3 mt-3 trending_card_box position-relative"
                        key={productIndex}
                      >
                        {items?.customerDiscount !== 0 && (
                          <div className="position-absolute top-1 translate-middle-x start-50 discountOff">
                            {items?.customerDiscount}% {translation?.off}
                          </div>
                        )}

                        <img
                          className="w-100 i-rd"
                          src={getImageUrl(items?.small)}
                          alt="img"
                          onError={imageError}
                          onClick={() => handleClick(items)}
                        />
                      </div>
                    ))}

                  {validProducts.length > showMoreAfter && (
                    <div className="col-md-2 col-sm-3 col-4 mb-3 trending_card_box mt-3">
                      <div
                        className="w-100 i-rd d-flex flex-column align-items-center justify-content-center text-center  trending_show_more"
                      >
                        <span
                          onClick={() => {
                            trackEvent("link_click", {
                              title: `${translation?.more} ${translation?.eGiftCards}`,
                              page_url: "/productlist?trending=true",
                              section_title: item?.sectionName,
                            });

                            const trendingValue = "true";
                            const specialIdValue = item?.id.toString();

                            const finalTrending =
                              process.env.REACT_APP_IS_ENCRYPTION_ENABLED ===
                              "false"
                                ? trendingValue
                                : encryptURLParam(trendingValue);

                            const finalSpecialId =
                              process.env.REACT_APP_IS_ENCRYPTION_ENABLED ===
                              "false"
                                ? specialIdValue
                                : encryptURLParam(specialIdValue);

                            navigate(
                              `/productlist?trending=${finalTrending}&specialId=${finalSpecialId}`,
                              {
                                state: {
                                  isTrending: true,
                                  productData: item?.products,
                                  name: item?.sectionName,
                                },
                              }
                            );
                          }}
                        >
                          <div className="text-center mt-2">
                            <span className="upto">{translation?.more}</span>
                            <p className="poin">{translation?.eGiftCards}</p>
                          </div>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default TrendingGiftCards;
